import React, { Component } from "react"
import classnames from "classnames"
import { SaveIcon, ShareIcon, Interactive } from "AtomicComponents"
import { SaveForm, ShareForm, Tooltip } from "AtomicContainers"
import { A, P, Modal } from "AtomicComponents"
import styles from "./SaveShareCopy.less"
import { IS_MOBILE } from "AtomicUtils/environment"
import { MobileShare } from "containers"
import gtmHandler from "AtomicUtils/gtmHandler"

class SaveShareCopy extends Component {
  constructor(props) {
    super(props)

    this.state = {
      saveFormOpen: false,
      shareFormOpen: false,
      showMobileShare: true,
      showTooltipOfSaveInSummary: false
    }
  }

  componentDidMount() {
    const { disableSavePrompt = false, delayToShowSavePrompt = 1000, delayToCloseSavePrompt = 3000, enabled } = this.props
    const { showTooltipOfSaveInSummary } = this.state
    if (
      !disableSavePrompt
      && enabled
      && !showTooltipOfSaveInSummary
    ) {
      setTimeout(() => {
        this.setState({
          showTooltipOfSaveInSummary: true
        }, () => {
          setTimeout(() => {
            this.setState({
              showTooltipOfSaveInSummary: false
            })
          }, delayToCloseSavePrompt)
        })
      }, delayToShowSavePrompt)
    }
  }

  componentDidUpdate(prevProps) {
    const { enabled, disableSavePrompt = false, delayToShowSavePrompt = 1000, delayToCloseSavePrompt = 3000 } = this.props
    const { showTooltipOfSaveInSummary } = this.state
    if (
      prevProps.enabled != enabled
      && !disableSavePrompt
      && enabled
      && !showTooltipOfSaveInSummary
    ) {
      setTimeout(() => {
        this.setState({
          showTooltipOfSaveInSummary: true
        }, () => {
          setTimeout(() => {
            this.setState({
              showTooltipOfSaveInSummary: false
            })
          }, delayToCloseSavePrompt)
        })
      }, delayToShowSavePrompt)
    }
  }

  _handleClickOnOpeningSaveModal = () => {
    const { gtmEvents = {} } = this.props

    this.setState({ saveFormOpen: true }, () => {
      gtmHandler({
        pageCategory: gtmEvents.category,
        pageAction: `${gtmEvents.action} - Clicked "SAVE"`
      })
    })
  }

  render() {
    const {
      enabled = true,
      descriptionSave,
      descriptionShare,
      locationState,
      imageSrc,
      namePlate,
      bodyStyle,
      safetyModelExcess,
      compareUrl,
      saveEndPoint,
      shareEndPoint,
      findDealerUrl,
      financeOptionText,
      gtmEvents
    } = this.props
    const { showTooltipOfSaveInSummary } = this.state

    return (
      <div
        data-test="save-share"
        className={classnames({
          [styles.ShareSection]: true,
          [styles.ShareSectionDisabled]: !enabled
        })}>
        <div className={classnames({ [styles.ShareSectionColumn]: true })}>
          <div
            onClick={() => {
              this.setState({ saveFormOpen: true })
              gtmHandler({
                pageCategory: gtmEvents.category,
                pageAction: `${gtmEvents.action} - Clicked "SAVE"`
              })
            }}
            key="SavePart"
            className={classnames({ [styles.ShareSectionText]: true })}
            key="SaveText">
            <SaveIcon
              style={{ width: "22px", height: "22px", margin: "0 8px 0 0" }}
            />
            <Interactive>SAVE</Interactive>
          </div>
          {showTooltipOfSaveInSummary && enabled &&
            <Tooltip position="bottomLeft">
              <div style={{ letterSpacing: 0 }}>
                <P withoutMargin>
                You can now <A onClick={this._handleClickOnOpeningSaveModal}> save your {namePlate && namePlate.length === 2 ? namePlate[0] + " and " + namePlate[1] : "cars"} </A> for future reference.
                  </P>
              </div>
            </Tooltip>
          }
        </div>
        {
          this.state.saveFormOpen &&
          <Modal
            width="600px"
            handleClose={() => {
              this.setState({ saveFormOpen: false })
            }}>
            <SaveForm
              endPoint={saveEndPoint}
              description={descriptionSave}
              location={locationState}
              imageSrc={imageSrc}
              namePlate={namePlate}
              bodyStyle={bodyStyle}
              safetyModelExcess={safetyModelExcess}
              financeOptionText={financeOptionText}
              compareUrl={compareUrl}
              findDealerUrl={findDealerUrl}
              gtmEvents={gtmEvents}
              fullWidth
              handleClose={() => {
                this.setState({ saveFormOpen: false })
              }}
            />
          </Modal>
        }
        <div className={classnames({ [styles.ShareSectionColumn]: true })}>
          <div
            onClick={() => {
              this.setState({ shareFormOpen: true })
              !IS_MOBILE &&
                gtmHandler({
                  pageCategory: gtmEvents.category,
                  pageAction: `${gtmEvents.action} - Clicked "SHARE"`
                })
            }}
            key="SharePart"
            className={classnames({ [styles.ShareSectionText]: true })}
            key="ShareText">
            <ShareIcon
              style={{ width: "22px", height: "22px", margin: "0 8px 0 0" }}
            />
            <Interactive>SHARE</Interactive>
          </div>
        </div>
        {
          this.state.shareFormOpen &&
          <Modal
            width="600px"
            handleClose={() => {
              this.setState({
                shareFormOpen: false,
                showShareForm: false,
                showMobileShare: true
              })
            }}>
            {IS_MOBILE &&
              this.state.showMobileShare && (
                <MobileShare
                  mobileDescription={"How would you like to share your Mazda comparision?"}
                  description={`Check out the ${
                    namePlate && namePlate.length === 2
                      ? namePlate[0] + " and " + namePlate[1]
                      : "cars"
                  } I compared: `}
                  EmailShareFunc={() => {
                    this.setState({
                      showShareForm: true,
                      showMobileShare: false
                    })
                  }}
                />
              )}
            {(!IS_MOBILE || this.state.showShareForm) && (
              <ShareForm
                endPoint={shareEndPoint}
                description={descriptionShare}
                location={locationState}
                imageSrc={imageSrc}
                namePlate={namePlate}
                bodyStyle={bodyStyle}
                safetyModelExcess={safetyModelExcess}
                compareUrl={compareUrl}
                findDealerUrl={findDealerUrl}
                gtmEvents={gtmEvents}
                fullWidth
                handleClose={() => {
                  this.setState({ shareFormOpen: false })
                }}
              />
            )}
          </Modal>
        }
      </div>
    )
  }
}

export default SaveShareCopy



// WEBPACK FOOTER //
// ./src/AtomicContainers/SaveShareCopy/SaveShareCopy.jsx